<template>
	<div id="top">
		<nav class="main-nav fix-on-scroll" :class="{ 'show-mobile-nav': showMobileNav }">
			<div class="row">
				<div class="columns column12">
					<div class="nav-bar">
						<nuxt-link class="logo" :to="{ path: localePath('/', locale), hash: '#top' }" />
						<div class="nav-content">
							<ul>
								<li class="menu-close" @click="hideMobileNav">
									<font-awesome-icon :icon="`fal fa-times`" size="1x" />
								</li>
								<li v-for="item in topmenu[locale]" :key="item.filename" @click="hideMobileNav">
									<nuxt-link :to="item.filename">
										{{ item.header }}
									</nuxt-link>
								</li>
							</ul>
						</div>
						<div class="buttons">
							<div class="menu-button mobile-only" @click="toggleMobileNav">
								<font-awesome-icon class="icon" icon="fal fa-bars" size="1x" />
								<!--<span>{{ $t('buttonMenu') }}</span>-->
							</div>
							<book-button class="button book-now cta reserve-now">
								<font-awesome-icon class="icon" icon="fal fa-calendar-alt" size="1x" />
								<span>{{ $t('bookNow') }}</span>
							</book-button>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</div>
</template>

<script setup>
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

if (!defaults.value) {
	await fetchDefaults();
}

const showMobileNav = ref(false);

const { data: topmenu } = await useWebsiteFetch('topmenu');

const toggleMobileNav = () => {
	showMobileNav.value = !showMobileNav.value;
};

const hideMobileNav = () => {
	showMobileNav.value = false;
};
</script>

<style lang="scss" scoped>
.mobile-only {
	display: none !important;
}

.main-nav {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	transition: all 0.3s ease-in-out;

	a:not(.button, .logo) {
		color: #fff;
		text-transform: uppercase;
		text-decoration: none;
		margin: 0 12px;
		letter-spacing: 1px;
		font-size: 15px;
		font-weight: 400;
	}

	&.fixed {
		background: var(--primary-background-color);
		box-shadow: 0 0 20px rgb(0 0 0 / 10%);

		a:not(.button, .logo) {
			color: var(--cta-color);
		}

		.logo {
			background: url('~/assets/images/logo-dedijketelg-full-wide.png') no-repeat center center;
			background-size: 217px;
			width: 217px;
			height: 88px;
		}

		.lang-select {
			color: var(--cta-color);
			border-left: 1px solid var(--cta-color);

			svg {
				color: var(--cta-color);
			}
		}
	}

	ul li {
		display: inline-block;
	}
}

.no-heading-image {
	.main-nav {
		background: var(--primary-background-color);
		box-shadow: 0 0 20px rgb(0 0 0 / 10%);

		a:not(.button, .logo) {
			color: var(--cta-color);
		}

		.logo {
			background: url('~/assets/images/logo-dedijketelg-full-wide.png') no-repeat center center;
			background-size: 217px;
			width: 217px;
			height: 88px;
		}

		.lang-select {
			color: var(--cta-color);
			border-left: 1px solid var(--cta-color);

			svg {
				color: var(--cta-color);
			}
		}
	}
}

.nav-bar {
	display: flex;
	align-items: center;
	padding: 0;
	z-index: 9;
	position: relative;

	.buttons {
		display: flex;
		align-items: center;
		gap: 10px;

		.button {
			padding: 15px 25px;
			margin: 0;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.icon {
			display: none;
			margin-right: 5px;
		}
	}
}

.logo {
	padding: 0;
	text-decoration: none;
	margin: 0;
	background: url('~/assets/images/logo-dedijketelg-full-square.png') no-repeat center center;
	background-size: 167px;
	width: 167px;
	height: 167px;
	transition: all 0.3s ease-in-out;
}

.nav-content {
	flex-grow: 1;
	text-align: center;

	.menu-close {
		color: #000;
		display: none;
		font-size: 30px;
		cursor: pointer;
		position: absolute;
		top: 15px;
		width: auto;
		right: 20px;
		padding: 0;
		margin: 0;
	}
}

.language {
	margin: 10px 0;

	.flag::before {
		content: '';
		width: 16px;
		position: relative;
		top: 3px;
		height: 16px;
		margin-right: 6px;
		display: inline-block;
	}

	.flag.en::before {
		background: url('~/assets/images/en.png') no-repeat;
	}

	.flag.nl::before {
		background: url('~/assets/images/nl.png') no-repeat;
	}

	.flag.de::before {
		background: url('~/assets/images/de.png') no-repeat;
	}

	.flag.fr::before {
		background: url('~/assets/images/fr.png') no-repeat;
	}

	.flag.es::before {
		background: url('~/assets/images/es.png') no-repeat;
	}
}

.language-navigation:hover .lang-nav-sel,
.language-navigation:hover .fa-globe {
	color: var(--cta-color);
}

.lang-nav-sel {
	box-shadow: none;
	cursor: pointer;
	width: 30px;
	padding: 0 4px 0 0;
	color: #fff;
	border: none;
	text-transform: uppercase;
	font-size: 12px;
	font-family: sans-serif;
	appearance: none;
	background: url('~/assets/images/dropdown.png') right 1px center no-repeat;
	background-size: 7px;
	transition: color 0.3s ease-in-out;

	option {
		color: var(--body-color);
	}

	&::-ms-expand {
		display: none;
	}
}

.lang-select {
	padding: 8px 20px;
	margin: 0 10px;
	border-left: 1px solid #e5e5e5;
	position: relative;
	cursor: pointer;
	text-transform: uppercase;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	color: #fff;

	span {
		margin: 0 4px;
	}

	svg {
		font-size: 16px;
		color: #fff;
	}

	img {
		width: 16px;
		float: left;
		margin: 0 5px 0 0;
	}

	a {
		width: 100%;
		float: left;
		color: var(--body-color);
		text-decoration: none;
		margin: 4px 0;
		text-transform: uppercase;

		&.active {
			color: var(--cta-color);
		}
	}
}

.lang-wrapper {
	display: none;
	position: absolute;
	top: 35px;
	left: 3px;
	right: 3px;
	padding: 10px 9px;
	text-align: center;
	background: var(--primary-background-color);
	box-shadow: 0 18px 18px rgb(0 0 0 / 10%);
	z-index: 90;

	&.active,
	a {
		display: flex;
		flex-flow: column nowrap;
		place-content: space-between center;
		color: #000 !important;
		font-size: 13px;
		gap: 5px;
	}

	a {
		width: 100%;
		flex-direction: row;
	}

	img {
		width: 16px;
		height: 16px;
		margin: 2px 0 0;
	}
}

.language-navigation .fa-globe {
	margin: 0 2px 0 0;
	transition: color 0.3s ease-in-out;
}

@media (max-width: 1280px) {
	.nav-bar a {
		font-size: 14px;
	}
}

@media (max-width: 1200px) {
	.menu-button {
		text-transform: uppercase;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: space-between;
		margin: 0 10px 0 0;
		cursor: pointer;

		svg {
			font-size: 29px;
			color: #000;
		}

		span {
			margin: 0 0 0 5px;
		}
	}

	.mobile-only {
		display: flex !important;

		&.lang-nav {
			display: inline-block !important;
			margin: 30px 0 0;
			padding: 0 10px;
		}
	}

	.language-navigation {
		display: none;
	}

	.nav-bar .buttons .icon {
		display: unset;
	}

	.main-nav {
		background: var(--primary-background-color);
		box-shadow: 0 0 20px rgb(0 0 0 / 10%);

		a:not(.button, .logo) {
			color: var(--cta-color);
		}

		.logo {
			background: url('~/assets/images/logo-dedijketelg-full-wide.png') no-repeat center center;
			background-size: 217px;
			width: 217px;
			height: 88px;
		}

		.lang-select {
			color: var(--cta-color);
			border-left: 1px solid var(--cta-color);

			svg {
				color: var(--cta-color);
			}
		}

		.columns {
			padding: 0 20px 0 0;
		}

		.row {
			width: 100%;
		}

		&.show-mobile-nav {
			.nav-content ul {
				display: flex;
				flex-direction: column;
				justify-content: center;
				text-align: center;
				opacity: 1;
				visibility: visible;
				transition: opacity 0.3s ease-in-out;
				background: url('~/assets/images/border-pattern-red.png') repeat-x bottom 50px center
					var(--primary-background-color);

				li:not(.menu-close) {
					width: 100%;
				}

				li:not(.lang-nav, .menu-close) {
					margin: 7px auto;
					max-width: 270px;

					a {
						font-size: 26px;
						padding: 3px 0;
						border-top: 1px solid var(--primary-background-color);
						border-bottom: 1px solid var(--primary-background-color);
						display: inline-block;
						text-align: center;

						&:hover,
						&.active {
							border-color: var(--cta-color);
						}
					}
				}
			}
		}

		ul {
			position: fixed;
			inset: 0;
			background: var(--primary-background-color);
			text-align: center;
			padding: 20px;
			opacity: 0;
			visibility: hidden;
			overflow-y: scroll;
		}
	}

	.nav-content .menu-close {
		display: block;
		color: var(--cta-color);
	}
}

@media (max-width: 880px) {
	.nav-bar .buttons {
		.button {
			padding: 16px;
		}

		.menu-button {
			margin-right: 5px;

			.icon {
				font-size: 22px;
			}
		}

		.icon {
			margin-right: 0;
			font-size: 16px;
		}

		span {
			display: none;
		}
	}

	.main-nav {
		&.show-mobile-nav {
			.nav-content ul {
				li:not(.lang-nav, .menu-close) {
					max-width: 100%;
				}
			}
		}
	}
}

@media (max-width: 580px) {
	.nav-bar .buttons span {
		display: none;
	}

	.nav-bar .logo {
		font-size: 22px;
	}
}
</style>
